import { LabOrderInput } from 'models/order-input/lab-order';
import { createContext, Dispatch, SetStateAction } from 'react';

type LabOrderContextType = {
    order: LabOrderInput;
    setOrder: Dispatch<SetStateAction<LabOrderInput>>;
    isTioTandvardPricingEnabled: boolean;
    setIsTioTandvardPricingEnabled: Dispatch<SetStateAction<boolean>>;
    isProductionPlanningEnabled: boolean;
};
export const LabOrderContext = createContext<LabOrderContextType>({
    order: {} as LabOrderInput,
    setOrder: () => {
        return;
    },
    isTioTandvardPricingEnabled: false,
    setIsTioTandvardPricingEnabled: () => {
        return;
    },
    isProductionPlanningEnabled: false,
});
